import { Autocomplete } from '@mui/material';
import styled from 'styled-components';

export const SContainer = styled.div`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    height: 40px;
    width: 100%;
  }
`;

export const SAutocompleteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const SAutocompleteLabel = styled.span`
  color: ${({theme}) => theme.palette.colors.gray400};
`;

export const SAutocomplete = styled(Autocomplete)`
  min-width: 200px;
  background-color: ${({theme}) => theme.palette.colors.white};
`;
